import { create, StateCreator } from 'zustand';
import { persist, PersistOptions } from 'zustand/middleware';

// FIXME: This is not good...
export const createPersistentState = <S extends unknown>(
  name: string,
  initialState: StateCreator<S>,
  partialize?: PersistOptions<S, Partial<S>>['partialize']
) => create(persist(initialState, { name, partialize }));
